import { apiFetch } from '../authentication/authUtils';
import { getResponseErrorTitle } from '../shared/apiUtils';

export interface IdentityProvider {
    id: string;
    accountId: string;
    name: string;
    allowedAudience: string;
    clientId: string;
    wellKnownUrl: string;
    createdAt: string;
    updatedAt: string;
}

export interface PaginatedResultsResponse<T> {
    total: number;
    pageSize: number;
    page: number;
    results: T[];
}

export interface CreateIdentityProvider {
    name: string;
    allowedAudience: string;
    clientId: string;
    clientSecret: string;
    wellKnownUrl: string;
}

export interface IdentityProviderDetail extends IdentityProvider {
    clientId: string;
    clientSecret: string;
    wellKnownUrl: string;
}

export async function fetchIdentityProviders(
    page = 1,
    pageSize = 20,
): Promise<PaginatedResultsResponse<IdentityProvider>> {
    const response = await apiFetch(`/identityprovider?page=${page}&pageSize=${pageSize}`);

    if (!response.ok) {
        throw new Error(await getResponseErrorTitle(response));
    }

    return response.json() as Promise<PaginatedResultsResponse<IdentityProvider>>;
}

export async function createIdentityProvider(
    payload: CreateIdentityProvider,
): Promise<IdentityProvider> {
    const response = await apiFetch('/identityprovider', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    });

    if (!response.ok) {
        throw new Error(await getResponseErrorTitle(response));
    }

    return response.json() as Promise<IdentityProvider>;
}

export async function deleteIdentityProvider(id: string): Promise<void> {
    const response = await apiFetch(`/identityprovider/${id}`, { method: 'DELETE' });

    if (!response.ok) {
        throw new Error(await getResponseErrorTitle(response));
    }
}

export async function fetchIdentityProviderById(id: string): Promise<IdentityProviderDetail> {
    const response = await apiFetch(`/identityprovider/${id}`);

    if (!response.ok) {
        throw new Error(await getResponseErrorTitle(response));
    }

    return response.json() as Promise<IdentityProviderDetail>;
}

export async function updateIdentityProvider(
    id: string,
    payload: CreateIdentityProvider,
): Promise<IdentityProvider> {
    const response = await apiFetch(`/identityprovider/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    });

    if (!response.ok) {
        throw new Error(await getResponseErrorTitle(response));
    }

    return response.json() as Promise<IdentityProvider>;
}
